export async function addManagerQuestions({ token, userId, themename, lobby_name, questions }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/addManagerQuestions`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      userId,
      themename,
      lobby_name,
      questions,
    }),
  });

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.message || "Failed to save questions");
  }
  if (data && data.success === false) {
    throw new Error(data.message || "Failed to save questions");
  }
  return data;
}

